import React, { createElement, forwardRef, useContext, useLayoutEffect, useState, } from 'react';
import classnames from 'classnames';
import { getActiveIndex, getMarginStyle, getTransformByIndex, getTransformPropValue } from './utils';
import TabsContext from './TabsContext';
const TabContent = forwardRef(function TabContent(props, ref) {
    const { destroyInactiveTabPane, animated, animatedWithMargin, style } = props;
    const { prefixCls, totalPanelsMap, activeKey, tabBarPosition } = useContext(TabsContext);
    const [mergedStyle, setMergedStyle] = useState(() => animated ? ({
        ...style,
        display: 'none',
    }) : style);
    const classes = classnames(`${prefixCls}-content`, animated ? `${prefixCls}-content-animated` : `${prefixCls}-content-no-animated`);
    useLayoutEffect(() => {
        if (animated) {
            const activeIndex = getActiveIndex(totalPanelsMap, activeKey);
            if (activeIndex !== -1) {
                const animatedStyle = animatedWithMargin ?
                    getMarginStyle(activeIndex, tabBarPosition) :
                    getTransformPropValue(getTransformByIndex(activeIndex, tabBarPosition));
                setMergedStyle({
                    ...style,
                    ...animatedStyle,
                });
            }
            else {
                setMergedStyle({
                    ...style,
                    display: 'none',
                });
            }
        }
        else {
            setMergedStyle(style);
        }
    }, [animated, totalPanelsMap, activeKey, tabBarPosition, style]);
    const getTabPanes = () => {
        return [...totalPanelsMap.entries()].map(([key, { type, ...child }]) => createElement(type, {
            ...child,
            key,
            active: activeKey === key,
            destroyInactiveTabPane,
            rootPrefixCls: prefixCls,
        }));
    };
    return (React.createElement("div", { className: classes, style: mergedStyle, ref: ref }, getTabPanes()));
});
TabContent.defaultProps = {
    animated: true,
};
TabContent.displayName = 'TabContent';
export default TabContent;
